import { ua } from '../ua';

export function resizePolyFill() {
  try {
    import(/* webpackChunkName: "ie-polyfill" */ './resize-polyfill.js').then(module=>{
      module.resizePolyfill()
    });
  } catch (e) {
    console.error(e);
  }
}


export const setIEHtmlClassName = () => {
  try {
    const className = document.documentElement.getAttribute('class') || '';
    if (className) {
      document.documentElement.setAttribute('class', `${className} weapp-ie11`);    
    } else {
      document.documentElement.setAttribute('class', `weapp-ie11`);    
    }
  } catch (error) {
    console.error(error); 
  }
}

// 引用 core-js 兼容处理 ESNext 语法
export function loadCoreJsPolyfill () {
  // 兼容处理 Array.flat 语法
  import(/* webpackChunkName: "ie-polyfill" */ 'core-js/features/array/flat');
}

// 解决ie浏览器textarea不支持resize属性, 以及设置默认的html class类名
if (ua.browser === 'IE') {
  setIEHtmlClassName();
  resizePolyFill();
  loadCoreJsPolyfill();
}
